<template>
  <SplashWrapper :hide-buttons="true">
    <iColumn
      align="center"
      vertical-align="middle"
      width="fill"
      height="fill"
      gap="extraLarge"
    >
      <iColumn :width="500" align="center" gap="large">
        <iRow align="center">
          <iIcon :icon="icon" size="large" :variant="iconVariant" />
        </iRow>
        <iRow align="center">
          <iHeading align="center" variant="standard">
            {{ title }}
          </iHeading>
        </iRow>
        <iParagraph text-align="center">
          {{ description }}
        </iParagraph>
      </iColumn>
    </iColumn>
  </SplashWrapper>
</template>

<script>
import SplashWrapper from "@/components/splash/SplashWrapper";

export default {
  name: "InvitationError",
  components: {
    SplashWrapper,
  },
  props: {
    reason: {
      type: String,
      default: "",
    },
  },
  computed: {
    title() {
      if (this.reason === "expired") {
        return "Invitation Expired";
      }

      if (this.reason === "rejected") {
        return "Invitation Rejected";
      }

      return "Invitation No Longer Valid";
    },
    description() {
      if (this.reason === "expired") {
        return "This invitation link has expired. Ask the sender to send you a new invitation.";
      }

      if (this.reason === "rejected") {
        const supportEmail = this.publicationData.support_email_address;
        return `You have rejected the invitation to become a collaborator. If this was a mistake, please reach out to ${supportEmail}.`;
      }

      return "We're sorry, but the invitation you're trying to access is no longer valid.";
    },
    icon() {
      if (this.reason === "expired") {
        return "clock";
      }

      return "exclamation-triangle";
    },
    iconVariant() {
      if (this.reason === "rejected") {
        return "warning";
      }

      return "error";
    },
  },
};
</script>
